export default __webpack_public_path__ + "static/media/John-Clifford.bcd3efc3.jpg";